exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/vendor/treeline-shared-components/tabs/tabs.scss
 ** module id = 267
 ** module chunks = 1 2 3 7 30 33 46
 **/